const items =
[
    {
        "id":1,
        'name':'Brings down your ongoing cost of running SAP ABAP, SAPUI5 and .net Developments.'
    },
    {
        "id":2,
        "name":'Handling skill gap and peak workloads within shorter time frame.'
    },
    {
        "id":3,
        "name":'Don’t need to maintain high cost technical skills and keep them updated.'
    },
    {
        "id":4,
        "name":'Brings best practices from industry and cross industries.'
    },
    {
        "id":5,
        "name":'Possibility of faster solution delivery using reusable components.'
    },
    {
        "id":6,
        "name":'24/7 services, works in your preferred time zone'
    },
    {
        "id":7,
        "name":'Adherence of project management practices.'
    },
    
]
export default items
